angular.module('rentalListingModule').component('rentalListingImages', {
	templateUrl: 'rentalListingImages/rentalListingImages.html',
	bindings: {
		listing: '<',
		isMobile: '<',
		uploadRpc: '<',
		uploadImageLimit: '<'
	},
	controller: ['$http', function($http) {
		this.listing.images = this.listing.images || [];
		this.listing.floorplans = this.listing.floorplans || [];
	}]
});
